module.exports = __webpack_public_path__ + "img/mp4-ic.6e8d57e7.svg";